import React from "react";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import SquareFootIcon from "@material-ui/icons/SquareFoot";
import TranslateIcon from "@material-ui/icons/Translate";

import { useApolloClient, useQuery } from "@apollo/client";

import { useQueryParam, StringParam } from "use-query-params";

import * as _ from "lodash";

// import moment from "moment";

import remoteOptionsQuery from "./remote-options-query";
import localOptionsQuery from "./local-options-query";

import { optionsVar } from "../../apollo-client";

const useStyles = makeStyles((theme: Theme) => createStyles({}));

interface Props {}

function Options(props: Props) {
  const classes = useStyles(props);

  const [
    anchorElLocale,
    setAnchorElLocale,
  ] = React.useState<null | HTMLElement>(null);

  const handleLocaleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElLocale(event.currentTarget);
  };

  const handleLocaleClose = () => {
    setAnchorElLocale(null);
  };

  const [
    anchorElUnitSystem,
    setAnchorElUnitSystem,
  ] = React.useState<null | HTMLElement>(null);

  const handleUnitSystemClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorElUnitSystem(event.currentTarget);
  };

  const handleUnitSystemClose = () => {
    setAnchorElUnitSystem(null);
  };

  const client = useApolloClient();
  const [locale, setLocale] = useQueryParam("locale", StringParam);
  const [unitSystem, setUnitSystem] = useQueryParam("units", StringParam);
  // console.log("Options from url: ", locale, unitSystem);
  const { data: local } = useQuery(localOptionsQuery);
  // console.log("localoptions in options", local);
  const { data, error, loading } = useQuery(remoteOptionsQuery);
  // console.log("remoteOptionsQuery data", data, error, loading);
  if (loading) {
    return <div>Loading...</div>;
  }
  if (error) {
    console.error(error?.message);
    return <div>Error! {error?.message || ""}</div>;
  }
  // TODO translate
  const unitSystems = [
    {
      code: "imperial",
      name: "Imperial",
    },
    {
      code: "metric",
      name: "Metric",
    },
  ];
  let needsReload = false;
  // TODO useEffect?
  if (
    !local?.options ||
    local.options.localeLanguage !== data.userOptions.localeLanguage ||
    (locale && locale !== data.userOptions.localeLanguage)
  ) {
    const effectiveLocale = locale ? locale : data.userOptions.localeLanguage;
    optionsVar({
      ...local?.options,
      localeLanguage: effectiveLocale,
    });
    if (effectiveLocale !== data.userOptions.localeLanguage) {
      client.writeQuery({
        query: remoteOptionsQuery,
        data: {
          ...data,
          userOptions: {
            ...data?.userOptions,
            localeLanguage: effectiveLocale,
          },
        },
      });
      needsReload = true;
    }
  }
  if (
    !local?.options ||
    local.options.unitSystem !== data.userOptions.unitSystem ||
    (unitSystem && unitSystem !== data.userOptions.unitSystem)
  ) {
    const effectiveUnitSystem = unitSystem
      ? unitSystem
      : data.userOptions.unitSystem;
    optionsVar({
      ...local?.options,
      unitSystem: effectiveUnitSystem,
    });
    if (effectiveUnitSystem !== data.userOptions.unitSystem) {
      client.writeQuery({
        query: remoteOptionsQuery,
        data: {
          ...data,
          userOptions: {
            ...data?.userOptions,
            unitSystem: effectiveUnitSystem,
          },
        },
      });
      needsReload = true;
    }
  }
  // TODO
  // if (!!needsReload) {
  //   window.location.reload();
  // }
  // if (!local?.options || local.options.timeZone !== data.userOptions.timeZone) {
  //   client.writeData({ data: { options: {...local?.options, timeZone: data.userOptions.timeZone} } });
  // }
  // FIXME localize unitSystem values
  // FIXME save unitSystem and locale locally (either in react context and/or storage)
  // TODO useUrlParams?
  return (
    <>
      <Button
        startIcon={<TranslateIcon />}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleLocaleClick}
        color="inherit"
        style={{ margin: "0px" }}
      >
        <Hidden smDown>
          {data.languages.find(
            (x: any) => x.code === local?.options?.localeLanguage
          )?.name || null}
        </Hidden>
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorElLocale}
        keepMounted
        open={Boolean(anchorElLocale)}
        onClose={handleLocaleClose}
      >
        {_.sortBy(data.languages, "name").map((lang: any) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === local?.options?.localeLanguage}
            value={lang.code}
            onClick={async (event) => {
              // console.log("language change", lang.code);
              if (lang.code) {
                await client.cache.reset();
                optionsVar({
                  ...local.options,
                  localeLanguage: lang.code as string,
                });
                client.writeQuery({
                  query: remoteOptionsQuery,
                  data: {
                    ...data,
                    userOptions: {
                      ...data?.userOptions,
                      localeLanguage: lang.code as string,
                    },
                  },
                });
                setLocale(lang.code as string);
                window.location.reload();
              }
            }}
          >
            {lang.name}
          </MenuItem>
        ))}
      </Menu>
      {/* <Select
          // IconComponent={() => <ArrowDropDownIcon color="secondary" />}
          input={<Input disableUnderline />}
          value={local.options.localeLanguage}
          onChange={async (event) => {
            console.log("language change", event.target.value);
            if (event.target.value) {
              await client.cache.reset();
              optionsVar({
                ...local.options,
                localeLanguage: event.target.value as string,
              });
              client.writeQuery({
                query: remoteOptionsQuery,
                data: {
                  ...data,
                  userOptions: {
                    ...data?.userOptions,
                    localeLanguage: event.target.value as string,
                  },
                },
              });
              setLocale(event.target.value as string);
              window.location.reload();
            }
          }}
          // style={{ width: "100%" }}
        >
          {_.sortBy(data.languages, "name").map((lang: any) => (
            <MenuItem key={lang.code} value={lang.code}>
              {lang.name}
            </MenuItem>
          ))}
        </Select> */}
      <Button
        startIcon={<SquareFootIcon />}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleUnitSystemClick}
        color="inherit"
      >
        <Hidden smDown>
          {unitSystems.find((x: any) => x.code === local?.options?.unitSystem)
            ?.name || null}
        </Hidden>
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorElUnitSystem}
        keepMounted
        open={Boolean(anchorElUnitSystem)}
        onClose={handleUnitSystemClose}
      >
        {_.sortBy(unitSystems, "name").map((unitSystem: any) => (
          <MenuItem
            key={unitSystem.code}
            selected={unitSystem.code === local?.options?.unitSystem}
            value={unitSystem.code}
            onClick={async (event) => {
              // console.log("units change", unitSystem.code);
              if (unitSystem.code) {
                await client.cache.reset();
                optionsVar({
                  ...local.options,
                  unitSystem: unitSystem.code as string,
                });
                client.writeQuery({
                  query: remoteOptionsQuery,
                  data: {
                    ...data,
                    userOptions: {
                      ...data?.userOptions,
                      unitSystem: unitSystem.code as string,
                    },
                  },
                });
                setUnitSystem(unitSystem.code as string);
                window.location.reload();
              }
            }}
          >
            {unitSystem.name}
          </MenuItem>
        ))}
      </Menu>
      {/* <Select
          input={<Input disableUnderline />}
          value={local.options.unitSystem}
          onChange={async (event) => {
            console.log("units change", event.target.value);
            if (event.target.value) {
              await client.cache.reset();
              optionsVar({
                ...local.options,
                unitSystem: event.target.value as string,
              });
              client.writeQuery({
                query: remoteOptionsQuery,
                data: {
                  ...data,
                  userOptions: {
                    ...data?.userOptions,
                    unitSystem: event.target.value as string,
                  },
                },
              });
              setUnitSystem(event.target.value as string);
              window.location.reload();
            }
          }}
          // style={{ width: "100%" }}
        >
          <MenuItem value="metric">Metric</MenuItem>
          <MenuItem value="imperial">Imperial</MenuItem>
        </Select> */}
    </>
  );
}

export default Options;
